import React, { useState } from 'react'
import { DocumentSection } from '../../entities/Document'
import { MatrixContainer, MatrixWrapper } from './DocumentationMatrix.styles'
import { MatrixHeader } from './MatrixHeader'
import { FreshTableView } from './FreshTableView/FreshTableView'
import { CardView } from './CardView'
import { DocumentationModal } from '../DocumentationModal/DocumentationModal'

interface DocumentationMatrixProps {
  sections: DocumentSection[]
  projectName: string
}

export const DocumentationMatrix: React.FC<DocumentationMatrixProps> = ({
  sections,
  projectName
}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSetion, setSelectedSection] = useState<DocumentSection | null>(null)
  
  const handleSectionClick = (section: DocumentSection) => {
    setSelectedSection(section);
    setIsModalOpen(true);
  }

  return (
    <MatrixWrapper>
      {/* Заголовок вынесен за пределы таблицы */}
      <MatrixHeader projectName={projectName} />

      <MatrixContainer>
        {/* Таблица для больших экранов */}
        <FreshTableView sections={sections} onDocumentationClick={handleSectionClick}/>

        {/* Карточки для маленьких экранов */}
        <CardView sections={sections} />
        {selectedSetion && <DocumentationModal isOpened={isModalOpen} selectedSection={selectedSetion} onClose={() => setIsModalOpen(false)}/>}
      </MatrixContainer>
    </MatrixWrapper>
  )
}
